import type { FC } from 'react';
import { useCallback } from 'react';
import { getReferencesOptions } from '../../facebook';
import { observer } from 'mobx-react-lite';
import useRulePageMode from '../../hooks/useRulePageMode';
import useCurrentTasksFormStore from '../../hooks/useCurrentTasksFormStore';
import type { OptionValue } from '../../../../types/shared';
import { useCurrentNetwork } from '../../../../hooks';
import { useSuspenseQuery } from '@tanstack/react-query';
import { RuleEditAutoCompleteStyled } from '../RuleEditComponents';
import type { ConditionVariantProps } from '../../types';

export const PeriodsMetrics: FC<ConditionVariantProps> = observer(
  ({ indexCondition, indexTask, field, indexVariant }) => {
    const { isRead } = useRulePageMode();
    const isVariant = typeof indexVariant === 'number';
    const disabled = isRead || isVariant;
    const tasksFormStore = useCurrentTasksFormStore();
    const handleChangeMetric = useCallback(
      (value: OptionValue) => {
        tasksFormStore.setConditionMetric(indexTask, indexCondition, field, value as string);
      },
      [indexTask, indexCondition, field, tasksFormStore]
    );
    const network = useCurrentNetwork();
    const { data: periods } = useSuspenseQuery({
      ...getReferencesOptions(network),
      select: (data) => data.conditions.periods.map(({ name, id }) => ({ value: id, label: name })),
    });

    const value = isVariant
      ? tasksFormStore.getVariantOnTaskCondition(indexTask, indexVariant, indexCondition)?.[field]
      : tasksFormStore.getConditionMetric(indexTask, indexCondition)?.[field];

    return (
      <RuleEditAutoCompleteStyled
        allSelectable={false}
        value={value}
        onChange={handleChangeMetric}
        id={`Autocomplete-${field}-${indexTask}-${indexCondition}`}
        options={periods ?? []}
        InputProps={{ disabled: disabled }}
      />
    );
  }
);

export default PeriodsMetrics;
